import { StarIcon } from '@heroicons/react/solid'

export default function StarFeatured({ size = 'h-5 w-5 text-yellow-400' }) {
    return (
        <>
            <div className="">
                <div className="flex items-center">
                    <div className="flex-shrink-0 justify-center flex">
                        <StarIcon
                            className={`${size} text-yellow-400`}
                            aria-hidden="true"
                        />
                        <StarIcon
                            className={`${size} text-yellow-400`}
                            aria-hidden="true"
                        />
                        <StarIcon
                            className={`${size} text-yellow-400`}
                            aria-hidden="true"
                        />
                        <StarIcon
                            className={`${size} text-yellow-400`}
                            aria-hidden="true"
                        />
                        <StarIcon
                            className={`${size} text-yellow-400`}
                            aria-hidden="true"
                        />
                    </div>
                    <div className="min-w-0 flex-1 pl-2 py-1  text-gray-500 sm:py-3">
                        <span className="font-semibold text-olm-new-black md:text-xl">
                            Rated 5 stars
                        </span>{' '}
                    </div>
                </div>
            </div>
        </>
    )
}
